import React, { useState } from "react";
import styles from '../index.module.css';
import LoginLogo from '../../../../assets/images/brand/study_hub_logo.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { resetPasswordSubmit } from "../../../../redux/features/auth/authService";
import { useDispatch, useSelector } from "react-redux";
import BeatLoader from "react-spinners/BeatLoader";

const ResetPassword = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const accessToken = searchParams.get('access_token');
    const verificationCode = searchParams.get('verification_code');

    const { isResetPwLoading } = useSelector((state) => state.auth.resetPassword)

    const [formData, setFormData] = useState({
        password: '',
        confirmPassword: '',
    });

    const [errorMessages, setErrorMessages] = useState({
        password: '',
        confirmPassword: '',
    });
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrorMessages((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    const validateFormData = () => {
        const errors = {};
        if (!formData.password) {
            errors.password = 'Password is required.';
        }
        if (formData.password.length < 8) {
            errors.password = 'Password must be longer than or equal to 8 characters.';
        }
        if (!formData.confirmPassword) {
            errors.confirmPassword = 'Confirm Password is required.';
        } 
        if (formData.password !== formData.confirmPassword) {
            errors.confirmPassword = 'Password & Confirm Password should be matched.';
        }
        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            return false;
        } else {
            return true;
        }
    }

    const resetNewPassword = async () => {
        try {
            if (validateFormData(formData)) {
                const data = {
                    newPassword: formData.password,
                    access_token: accessToken,
                    verification_code: verificationCode
                }
                const response = await dispatch(resetPasswordSubmit(data)).unwrap();
                if (response.succcess) {
                    navigate('/auth/login');
                }
            }
        } catch (err) {
            setErrorMsg(err.message);
        }
    }

    const goHome = () => {
        navigate('/');
    }

    return (
        <>
            <div className={styles.authContainer}>
                <div className={styles.authCard}>
                    <div className={styles.authCardHeader}>
                        <img src={LoginLogo} alt="Logo" className={styles.logoImg} onClick={goHome} />
                        <h1 className={styles.authTitle}>Reset Password</h1>
                    </div>
                    <div className={styles.authCardBody}>
                        <div className={styles.formContainer}>
                            <form noValidate>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            New Password
                                        </label>
                                        <div className={`password-wrapper`}>
                                            <input
                                                type={passwordVisible ? "text" : "password"}
                                                id='password'
                                                name='password'
                                                placeholder="********************"
                                                value={formData.password}
                                                onChange={handleInputChange}
                                                className={`form-input-default`}
                                            />
                                            <FontAwesomeIcon
                                                icon={!passwordVisible ? faEyeSlash : faEye}
                                                onClick={() => setPasswordVisible(!passwordVisible)}
                                                className={`password-icon`}
                                            />
                                        </div>
                                        {errorMessages.username && (
                                            <p className={`text-danger`}>{errorMessages.username}</p>
                                        )}
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-group password-container`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Confirm New Password
                                        </label>
                                        <div className={`password-wrapper`}>
                                            <input
                                                type={confirmPasswordVisible ? "text" : "password"}
                                                id='confirmPassword'
                                                name='confirmPassword'
                                                placeholder="********************"
                                                value={formData.confirmPassword}
                                                onChange={handleInputChange}
                                                className={`form-input-default`}
                                            />
                                            <FontAwesomeIcon
                                                icon={!confirmPasswordVisible ? faEyeSlash : faEye}
                                                onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}
                                                className={`password-icon`}
                                            />
                                        </div>
                                        {errorMessages.confirmPassword && (
                                            <p className={`text-danger`}>{errorMessages.confirmPassword}</p>
                                        )}
                                        {errorMessages.password && (
                                            <p className={`text-danger`}>{errorMessages.password}</p>
                                        )}
                                    </div>
                                </div>
                                {errorMsg && (
                                    <p className={`text-danger`}>{errorMsg}</p>
                                )}
                                <button
                                    className={styles.authBtn}
                                    type='button'
                                    disabled={isResetPwLoading}
                                    onClick={resetNewPassword}
                                >
                                    {isResetPwLoading ? <BeatLoader color='#ffffff' /> : `Reset Password`}
                                </button>
                            </form>
                        </div>
                    </div>
                </div >
            </div >
        </>
    )
}

export default ResetPassword;